import React from 'react';

// REACT BOOTSTRAP
import { useAccordionButton } from 'react-bootstrap/AccordionButton';

// HELPERS
import { useDealTasks } from '../helpers/DealTasksProvider';

// FUNCTIONS
import { doCallback } from 'functions';

// GLOBAL COMPONENTS
import Button from 'core/tools/Button';

// MAIN COMPONENT
const TasksClose = ({ className, eventKey, resizeRow }) => {
  // HOOKS
  const { toggleExpanded } = useDealTasks() || {};

  // CALLBACKS
  const handleClick = useAccordionButton(eventKey, () => {
    doCallback(resizeRow);
    doCallback(toggleExpanded, eventKey);
  });

  // RENDER
  return <Button className={className} icon={{ use: 'cancel', size: 'xs' }} onClick={handleClick} />;
};

// EXPORT
export default TasksClose;
